import { AvailableModules, Features } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

export const UpsellContributorsEmptyState = ({
  requestSource,
  learnMoreNavigate,
  description,
}: {
  requestSource: string
  description: string
  learnMoreNavigate?: string
}) => {
  return (
    <UpsellingKit.EmptyState
      moduleRequested={AvailableModules.projects}
      featureRequested={Features.projects_contributors}
      requestReason={ValidReasons.MissingFeature}
      requestSource={requestSource}
      title={i18n.t('project_management.upselling.title')}
      description={description}
      buttonLabel={i18n.t('project_management.upselling.cta')}
      learnMoreNavigate={learnMoreNavigate}
    />
  )
}
